
export function basicRate(selling_price, gst_pct){
  if(!isNaN(selling_price)) {
    gst_pct = parseFloat(gst_pct)
    let basicRate = parseFloat((selling_price * 100) / (100+gst_pct)).toFixed(2)
    return parseFloat(basicRate)
  }
  else {
    return 0
  }
}

export function basicRateWithDiscountPct(selling_price, gst_pct, discount_pct) {
  // b = x-xp/100  // p = disc pct
  // s = b + bg/100  // g=gst pct
  // b = sx100/(100+g)

  if(!isNaN(selling_price)) {
    gst_pct = parseFloat(gst_pct)
    let temp_basic = parseFloat((selling_price * 100) / (100+gst_pct))
    if(!discount_pct || (discount_pct === 100)) {
      return parseFloat(parseFloat(temp_basic).toFixed(2))
    }

    let basic = parseFloat((temp_basic * 100)/(100-discount_pct)).toFixed(2)

    return parseFloat(basic)
  }
  else {
    return 0
  }
}

export function basicRateWithDiscountValue(selling_price, gst_pct, discount_value) {
  // b = x-xp/100  // p = disc pct
  // s = b + bg/100  // g=gst pct
  // b = sx100/(100+g)

  if(!isNaN(selling_price)) {
    gst_pct = parseFloat(gst_pct)
    let temp_basic = parseFloat((selling_price * 100) / (100+gst_pct))
    if(!discount_value || (discount_value === 0)) {
      return parseFloat(parseFloat(temp_basic).toFixed(2))
    }

    let basic = parseFloat(temp_basic+discount_value).toFixed(2)

    return parseFloat(basic)
  }
  else {
    return 0
  }
}



export function calculateSellingPrice(basic_rate, gst_pct) {

  let s = parseFloat(basic_rate + basic_rate*gst_pct/100).toFixed(2);
  return parseFloat(s)

}

export function calculateSellingPrice2(basic_rate, gst_pct) {

  let s = parseFloat(parseFloat(basic_rate) + parseFloat(basic_rate)*parseFloat(gst_pct)/100).toFixed(2);
  return parseFloat(s)

}

export function calculatePurchasePrice(basic_purchase_rate, gst_pct) {
  let p = parseFloat(basic_purchase_rate + basic_purchase_rate*gst_pct/100).toFixed(2)
  return parseFloat(p)
}


export function calculateTax(price, pct) {

  const t = parseFloat(price*pct/100).toFixed(2)
  return parseFloat(t)
}


export function calculateDiscount(price, rate) {

    const d = parseFloat(price*rate/100).toFixed(2)
    return parseFloat(d)
}



// WEBPACK FOOTER //
// ./src/utils/calculator.js